import classNames from 'classnames'
import { useContext, useRef } from 'react'
import styles from './index.module.scss'
import useOutsideOnClick from 'hooks/useOutsideOnClick'
import useBreakpoint from 'hooks/useBreakPoint'
import Icon from 'common/Icon'
import { DIM_GREY } from 'constants/colors'
import {
  ProviderFilterTypes,
  ProviderHeaderFilterTypes,
} from 'dataSource/ProviderSearch'
import { MobileFilterModalContext } from 'context/ProviderSearch/MobileFilterModalProvider'

type HeaderFilterButtonProps = {
  showButton?: boolean
  showDropdown: boolean
  setShowDropdown: (showDropdown: boolean) => void
  filterType: ProviderFilterTypes | ProviderHeaderFilterTypes
  containerClassName?: string
  buttonClassName?: string
  buttonTextClassName?: string
  onClick?: () => void
  text?: string
  title: string
  placeHolder?: string
  mobilePlaceHolder: string
  disableOutsideClick?: boolean
  disableMobileFilterModal?: boolean
}

const HeaderFilterButton: React.FC<HeaderFilterButtonProps> = ({
  showButton = true,
  showDropdown,
  setShowDropdown,
  filterType,
  containerClassName,
  buttonClassName,
  buttonTextClassName = '',
  children,
  text,
  title,
  placeHolder = '',
  mobilePlaceHolder = '',
  disableOutsideClick = false,
  disableMobileFilterModal = false,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { openMobileFilter } = useContext(MobileFilterModalContext)
  const { isMobileScreen, isLargeSize } = useBreakpoint()

  useOutsideOnClick({
    containerRef,
    callback: () => {
      if (showDropdown && !disableOutsideClick) {
        setShowDropdown(false)
      }
    },
  })

  const showMobileView = isMobileScreen || isLargeSize

  return (
    <div
      ref={containerRef}
      className={classNames(
        'position-relative d-flex align-self-stretch',
        containerClassName
      )}
    >
      {showButton && (
        <button
          aria-label={title + ' dropdown'}
          name="button"
          onClick={() => {
            showMobileView && !disableMobileFilterModal
              ? openMobileFilter(filterType)
              : setShowDropdown(true)
          }}
          className={classNames(
            buttonClassName,
            styles.selectable_header_button
          )}
        >
          <div className="flex-fill">
            {showMobileView ? (
              <div
                className={classNames('d-flex fs-16 justify-content-center', {
                  'text-slate-gray': !text, // Placeholder
                  'text-app-black font-weight-medium': !!text,
                })}
              >
                <div
                  className={classNames(
                    styles.selectable_button_text,
                    buttonTextClassName
                  )}
                >
                  {text || mobilePlaceHolder}
                </div>
              </div>
            ) : (
              <>
                <div className="fs-16 font-weight-medium">{title}</div>
                <div
                  data-has-value={!!text}
                  className={classNames(
                    styles.new_selectable_button_text,
                    buttonTextClassName
                  )}
                >
                  {text || placeHolder}
                </div>
              </>
            )}
          </div>
          {!showMobileView && !text && (
            <Icon
              icon="toggleDownArrow"
              className={styles.new_carrot_icon}
              fill={DIM_GREY}
            />
          )}
        </button>
      )}
      {showDropdown && children}
    </div>
  )
}

export default HeaderFilterButton
